import { gql } from "graphql-request";

export const GET_VISIBILITY_DUTY_SAVING_UTILIZED = gql`
  query DashboardVisibilityDutySavingsUtilized(
    $dashboardVisibility: DashboardImportMetricsInput
  ) {
    dashboardVisibilityDutySavingsUtilized(
      dashboardVisibility: $dashboardVisibility
    ) {
      data {
        year
        month
        totalDutySavings
      }
      meta {
        countDocs
      }
    }
  }
`;

export const GET_VISIBILITY_MANUFACTURERS = gql`
  query DashboardVisibilityGetManufacturers(
    $dashboardVisibility: DashboardImportMetricsInput
  ) {
    dashboardVisibilityGetManufacturers(
      dashboardVisibility: $dashboardVisibility
    ) {
      data {
        manufacturer
        manufacturerName
        tariffValue
        tariffDuty
        customValue
      }
      meta {
        countDocs
      }
    }
  }
`;

export const GET_VISIBILITY_OVERALL_IMPORTS = gql`
  query DashboardVisibilityOverallImportValue(
    $dashboardVisibility: DashboardImportMetricsInput
  ) {
    dashboardVisibilityOverallImportValue(
      dashboardVisibility: $dashboardVisibility
    ) {
      data {
        month
        totalGoodsValue
        year
      }
      meta {
        countDocs
      }
    }
  }
`;

export const GET_VISIBILITY_METRICS = gql`
  query DashboardVisibilityImportMetrics(
    $dashboardVisibility: DashboardImportMetricsInput
  ) {
    dashboardVisibilityImportMetrics(
      dashboardVisibility: $dashboardVisibility
    ) {
      data {
        distinctHts
        distinctImports
        totalDutySaving
        customsDuty
        customsValue
        distinctSuppliers
        avgShipmentValue
        effectiveDutyRates
        aceRange {
          minDate
          maxDate
        }
      }
      meta {
        countDocs
      }
    }
  }
`;

export const GET_VISIBILITY_TARIFF_HTS = gql`
  query DashboardVisibilityLineTariffValueByHts(
    $dashboardVisibility: DashboardLineTariffValueByHtsInput
  ) {
    dashboardVisibilityLineTariffValueByHts(
      dashboardVisibility: $dashboardVisibility
    ) {
      data {
        htsNumber
        tariffDuty
        tariffValue
      }
      meta {
        countDocs
      }
    }
  }
`;

export const GET_VISIBILITY_DUTY_SPEND = gql`
query DashboardVisibilityDutySpend($dashboardVisibility: DashboardDutySpendInput) {
  dashboardVisibilityDutySpend(dashboardVisibility: $dashboardVisibility) {
    data {
      dutySum
      totalMfnDuty
      totalMtbDuty
      total201Duty
      total232Duty
      total301Duty
      totalDutiesPaid
      totalOtherDuties
      totalExclusionsSaving
      totalDutySaving
      totalLineTariffGoodValueAmount
    }
    meta {
      countDocs
    }
  }
}`;

export const GET_VISIBILITY_IMPORT_EXPORT = gql`
  query DashboardVisibilityImportToExportTable(
    $dashboardVisibility: ImportToExportInput
  ) {
    dashboardVisibilityImportToExportTable(
      dashboardVisibility: $dashboardVisibility
    ) {
      data {
        exports {
          _id
          htsNumbers {
            id
            avgShipmentValue
            customDuty
            customValue
            distinctImports
            distinctImportsValues
            distinctSuppliers
            distinctSuppliersValues
            effectiveDutyRate
            entrySummaryCount
            dutySaved
          }
        }
        _id
      }
      meta {
        countDocs
      }
    }
  }
`;
